export const hasEMSAgencyAccessLevel = (emsAgenciesAccess, emsAgencyId: string, accessLevel: string) =>
  emsAgenciesAccess.some(item => item.emsAgencyId === emsAgencyId && item.accessLevel === accessLevel);
